/**
 * Folder names arrive from extraction as a sentence naming the document and
 * the parties to it:
 *
 *   "Order Schedule Number 1 between S&P Opco LLC and JPMorgan Chase & Co"
 *
 * The parties are the least useful part of the name to read as prose and the
 * most useful to see at a glance, so the row shows the part before "between"
 * as the title and the parties after it as a tag.
 */

/** Case-insensitive " between " — the first one only, so a party named
 *  "... between ..." can't split the name a second time. */
const BETWEEN = /\s+between\s+/i;

export interface ParsedFolderName {
  /** The name up to "between", or the whole name when there is no "between". */
  title: string;
  /** Everything after "between", verbatim; null when the name has no parties. */
  parties: string | null;
}

export const parseFolderName = (name: string): ParsedFolderName => {
  const match = BETWEEN.exec(name);
  if (!match) return { title: name, parties: null };

  const title = name.slice(0, match.index).trim();
  const parties = name.slice(match.index + match[0].length).trim();

  // "between" with nothing usable on one side of it is just part of the name.
  if (!title || !parties) return { title: name, parties: null };

  return { title, parties };
};
